

import { Box, DashboardModule, SidebarModalListItem } from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'

import type { TemplatePageModel } from '@models/types'

interface TemplatePageDetailsProps {
  additionalTemplatePageIds?: number[],
  templatePage: Partial<TemplatePageModel>,
}

const TemplatePageDetails = (props: TemplatePageDetailsProps) => {
  const { additionalTemplatePageIds = [], templatePage } = props

  const templatePagesById = useSelector(reduxState => reduxState.entities.templatePages)

  const selectedTemplatePages: Partial<TemplatePageModel>[] = [
    templatePage,
    ...additionalTemplatePageIds.map(templatePageId => templatePagesById[templatePageId] ?? { id: templatePageId }),
  ]

  const moduleTitle = `Selected Templates (${selectedTemplatePages.length})`
  const isLastRow = (index: number) => index === selectedTemplatePages.length - 1

  return (
    <DashboardModule title={moduleTitle}>
      <Box flexDirection="column"  maxHeight={360} overflowY="auto" paddingX="large">
        {selectedTemplatePages.map(selectedTemplatePage => (
          <Box key={selectedTemplatePage.id} marginTop="medium">
             <Box
              borderBottom={isLastRow(selectedTemplatePages.indexOf(selectedTemplatePage)) ? 0 : '1px dotted'}
              borderColor="lineColor"
              key={selectedTemplatePage.id}
              marginTop="medium"
            >
              <SidebarModalListItem
                boxProps={{ paddingY: 'medium' }}
                secondaryText={`Template Page ID #${selectedTemplatePage.id}`}
                title={selectedTemplatePage.title ?? 'Loading...'}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </DashboardModule>
  )
}

export default TemplatePageDetails
